import React from 'react';
import styled from 'styled-components';

const StripContainer = styled.div`
  overflow: hidden;
  background-color: #f3e11a;
  color: #000000;
  padding: 8px 0;
`;

const MovingText = styled.div`
  display: flex;
  justify-content: space-around;
  white-space: nowrap;
  animation: moveText 20s linear infinite;
  width: 200%; // Increased width to accommodate all text

  @keyframes moveText {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }
`;

const AnnouncementStrip: React.FC = () => (
  <StripContainer>
    <MovingText>
      <span>🎉 Ticket sales are live! Get your ticket now! 🎉</span>
      <span>🎁 Special Offer: Buy 3 Tickets, Get 1 Free! 🎁</span>
      <span>🎉 Ticket sales are live! Get your ticket now! 🎉</span>
      <span>🎁 Special Offer: Buy 3 Tickets, Get 1 Free! 🎁</span>
    </MovingText>
  </StripContainer>
);

export default AnnouncementStrip;
